import React from 'react';
import getConfig from 'next/config';
import { Modal } from '@bijie/react-bnb';
import styled from 'styled-components';
import { getLabel } from '../utils/i18n';
import urls from './urls';

const {
  external: { supportRequest },
} = urls;

const {
  publicRuntimeConfig: {
    assetPrefix,
  },
} = getConfig();

const Title = styled.h4`
  font-size: 24px;
  line-height: 31px;
  margin-bottom: 20px;
`;

const jumpToGoogleAuthen = (i18n) => {
  Modal.info({
    icon: <img src={assetPrefix + require('../static/images/2fa/googleAuthen.svg')} width="104" alt="error" />,
    content: (
      <div>
        <Title>{getLabel('usExchange-verification-reset-google-verification', i18n)}</Title>
        <p>{getLabel('usExchange-verification-reset-google-verification-content', i18n)}</p>
      </div>),
    okText: getLabel('usExchange-verification-reset-google-verification-submit', i18n),
    onOk: () => { window.open(supportRequest, '_blank'); },
    closable: true,
  });
};

const jumpToSmsAuthen = (i18n) => {
  Modal.info({
    icon: <img src={assetPrefix + require('../static/images/2fa/smsAuthen.svg')} width="104" alt="error" />,
    content: (
      <div>
        <Title>{getLabel('usExchange-verification-reset-sms-verification', i18n)}</Title>
        <p>{getLabel('usExchange-verification-reset-sms-verification-content', i18n)}</p>
      </div>),
    okText: getLabel('usExchange-verification-reset-google-verification-submit', i18n),
    onOk: () => { window.open(supportRequest, '_blank'); },
    closable: true,
  });
};

const twoFALocale = (i18n) => ({
  google: {
    title: getLabel('exchange-2fa-googleAuth', i18n),
    icon: 'computer',
    desc: getLabel('exchange-2fa-googleAuthDesc', i18n),
    label: getLabel('exchange-2fa-googleAuthLabel', i18n),
    error: '',
    footer: <a onClick={() => { jumpToGoogleAuthen(i18n); }}>{getLabel('exchange-2fa-phoneUnavailable', i18n)}</a>,
  },
  mobile: {
    title: getLabel('exchange-2fa-SMSAuth', i18n),
    icon: 'security',
    desc: getLabel('exchange-2fa-SMSAuthDesc', i18n),
    label: getLabel('exchange-2fa-SMSAuthLabel', i18n),
    error: '',
    send: getLabel('exchange-2fa-send', i18n),
    resend: getLabel('usExchange-2fa-reSend', i18n),
    resendSms: getLabel('usExchange-2fa-reSend', i18n),
    sendSuccessMsg: getLabel('exchange-2fa-sendSMSSuccess', i18n),
    sendFailMsg: getLabel('exchange-2fa-sendSMSFail', i18n),
    tip1: '',
    tip2: '',
    footer: <a onClick={() => { jumpToSmsAuthen(i18n); }}>{getLabel('exchange-2fa-phoneUnavailable', i18n)}</a>,
  },
  enable: {
    title: getLabel('exchange-2fa-enable2faTip', i18n),
    google: getLabel('exchange-2fa-googleAuth', i18n),
    auth: '',
    sms: getLabel('exchange-2fa-SMSAuth', i18n),
    risk: getLabel('exchange-2fa-notEnablingRisks', i18n),
    youWantToContinue: getLabel('exchange-2fa-continueWithout2FA', i18n),
    improveAccountSecurity: getLabel('exchange-2fa-improveYourSecurity', i18n),
    skip: getLabel('exchange-2fa-skipForNow', i18n),
    goBack: getLabel('exchange-2fa-goBack', i18n),
    enableSmsPath: '/usercenter/security/enable-sms-authenticator',
    enableGooglePath: '/usercenter/security/enable-google-authenticator',
  },
});

export default twoFALocale;
